// extracted by mini-css-extract-plugin
module.exports = {"code":"Code_code__w6Q7U"};